<template>
  <!-- Error page -->
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <h2 class="brand-text text-primary ml-1">
        MNS-FGL
      </h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          {{ $t('pagenotfound') }}🕵🏻‍♀️
        </h2>
        <p class="mb-2">
          {{ $t('pagenotfounddetails') }}😖
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          @click="redirectToHome"
        >
          {{ $t('backhome') }}
        </b-button>

        <!-- image -->
        <b-img
          fluid
          :src="imgUrl"
          alt="Error page"
        />
      </div>
    </div>
  </div>
  <!-- / Error page -->
</template>

<script>
/* eslint-disable global-require */
import { BLink, BButton, BImg } from 'bootstrap-vue'
import store from '@/store/index'
import { getRolesFromToken } from '@/services/JwtDecoder'
import router from '@/router' // Import the router

export default {
  components: {
    BLink,
    BButton,
    BImg,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/error.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/error-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  methods: {
    redirectToHome() {
      const roles = getRolesFromToken(localStorage.getItem('accessToken') || '')
      const roleStartPages = {
        SYSTEM: 'adminsearch',
        ADMIN: 'adminsearch',
        REVIEWER: 'adminsearch',
        APPROVER: 'requestsearch',
        USER: 'requestsearch',
        WORKER: 'updatesearch',
      }
      const redirectPath = Object.keys(roleStartPages).find(role => roles.includes(role))
      router.push({ name: roleStartPages[redirectPath] })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
